module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray-fc697eaba538fb276a4f90fc43c3dd97.png";